import { Moon, Sun } from 'lucide-react';
import { TEMA_ESCURO_ATIVO, useTheme } from '../theme/ThemeContext';

export default function ThemeToggle({ withLabel = false }) {
    const { theme, toggleTheme } = useTheme();

    // Tema escuro desligado por ora: não mostra o botão (ver TEMA_ESCURO_ATIVO).
    if (!TEMA_ESCURO_ATIVO) return null;

    const dark = theme === 'dark';
    return (
        <button
            type="button"
            className="ueb-theme-toggle"
            onClick={toggleTheme}
            aria-label={dark ? 'Ativar tema claro' : 'Ativar tema escuro'}
            title={dark ? 'Tema claro' : 'Tema escuro'}
        >
            {dark ? <Sun size={18} /> : <Moon size={18} />}
            {withLabel && <span>{dark ? 'Tema claro' : 'Tema escuro'}</span>}
        </button>
    );
}
